// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1CAHt","upload":"Small_upload__39swf","imageWrap":"Small_imageWrap__36XTl","removeBtn":"Small_removeBtn__2CZZc"};